import React, { Component, createRef, RefObject, ChangeEvent } from 'react';
import classNames from 'classnames';

import stylesTI from '../Input.module.scss';
import styles from './CodeInput.module.scss';
import Strings from '../../../Strings';

interface CodeInputProps {
  isCharAllowed?: boolean;
  isEsi?: boolean;
  num?: number;
  onChange?: () => void;
  val?: string;
}

interface CodeInputState {
  value: string;
}

export class CodeInput extends Component<CodeInputProps, CodeInputState> {
  inputRef: RefObject<HTMLInputElement | null>;
  
  constructor(props: CodeInputProps) {
    super(props);
    this.inputRef = createRef<HTMLInputElement | null>();
    this.state = { value: props.val || '' };
  }

  componentDidMount() {
    this.inputRef.current?.focus();
  }

  handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { num = 6, isCharAllowed } = this.props;
    let inputValue = e.target.value;
    
    // Only allow digits unless isCharAllowed
    if (!isCharAllowed) {
      inputValue = inputValue.replace(/\D/g, '');
    }
    
    // Limit to num characters
    inputValue = inputValue.slice(0, num);
    
    this.setState({ value: inputValue }, () => {
      this.props.onChange?.();
    });
  };

  getValue(): string {
    return this.state.value;
  }

  clear() {
    this.setState({ value: '' }, () => {
      this.inputRef.current?.focus();
    });
  }

  render() {
    const { isEsi, num = 6 } = this.props;
    const { value } = this.state;
    
    return (
      <div className={classNames(styles.CodeInput, isEsi && styles.isEsi)}>
        <label htmlFor="otp-code" className="visuallyhidden">
          {Strings.verificationCode || 'Verification code'}
        </label>
        <input
          ref={this.inputRef}
          type="text"
          inputMode="numeric"
          maxLength={num}
          id="otp-code"
          value={value}
          placeholder={'0'.repeat(num)}
          className={classNames(stylesTI.textInput, styles.singleInput)}
          onChange={this.handleChange}
          tabIndex={0}
          autoComplete="one-time-code"
          data-testid="otp-code"
        />
      </div>
    );
  }
}

export default CodeInput;
